import omsAxiosInstance from "../omsAxiosInstance";

export const templateService = {
  create: async (data) => {
    try {
      let response = await omsAxiosInstance.post("/mapping-template", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (type) => {
    try {
      const response = await omsAxiosInstance.get(
        `/mapping-template?type=${type}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  patch: async (id, data) => {
    try {
      let response = await omsAxiosInstance.patch(
        `/mapping-template/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await omsAxiosInstance.delete(`/mapping-template/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
